import React from "react";
import { Reveal } from "@/components/common";
import { EarlyAccessForm } from "@/components/EarlyAccessForm";

export const FinalCTASection = () => {
  return (
    <section id="early-access" data-testid="final-cta-section" className="relative py-20 sm:py-28 bg-[#091630] overflow-hidden">
      <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-[#21c55e]/15 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-[#06b6d4]/15 blur-3xl" />
      <div className="absolute inset-0 dotted-bg opacity-[0.15]" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div>
              <span className="inline-block text-xs tracking-[0.18em] uppercase text-[#21c55e] font-bold mb-4">
                Get started
              </span>
              <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
                Make Workpay your default <span className="text-[#21c55e]">payment link.</span>
              </h2>
              <p className="mt-5 text-lg text-slate-300">Start every project with clarity.</p>

              <div className="mt-8 flex flex-wrap gap-4 text-sm text-slate-300">
                <span className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-[#21c55e]" /> Join Early Access
                </span>
                <span className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-[#06b6d4]" /> Book a Demo
                </span>
                <span className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-white/50" /> Powered by Stripe
                </span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <EarlyAccessForm source="early_access" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
